import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export interface ThroughputPoint {
  bucket: string;
  count: number;
}

export function ThroughputChart({ data, label = 'objects' }: { data: ThroughputPoint[]; label?: string }) {
  if (!data.length) {
    return (
      <div className="flex h-48 items-center justify-center text-xs text-muted-foreground">
        No activity in window.
      </div>
    );
  }
  return (
    <div className="h-48 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="throughputFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(199 89% 55%)" stopOpacity={0.45} />
              <stop offset="100%" stopColor="hsl(199 89% 55%)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(222 18% 18%)" />
          {/* Bucket labels are pre-formatted by useManifestThroughput for the
              active timeframe (the data is pre-sorted by bucket start), so the
              axis renders them as-is. */}
          <XAxis dataKey="bucket" tick={{ fill: 'hsl(215 14% 65%)', fontSize: 11 }} stroke="hsl(222 18% 18%)" />
          <YAxis tick={{ fill: 'hsl(215 14% 65%)', fontSize: 11 }} stroke="hsl(222 18% 18%)" />
          <Tooltip
            contentStyle={{
              background: 'hsl(222 24% 9%)',
              border: '1px solid hsl(222 18% 18%)',
              borderRadius: 8,
              fontSize: 12,
            }}
            formatter={(value: number) => [`${value} ${label}`, '']}
          />
          <Area type="monotone" dataKey="count" stroke="hsl(199 89% 55%)" fill="url(#throughputFill)" strokeWidth={2} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
